<script>
  export const body = {
    key: 'updatewordfilter',
    data: {}
  }
</script>
